<nz-modal #modalRef nzSize [(nzVisible)]="isVisible"
  [nzTitle]="((isEdit ? 'Edit' : 'Add') + ' Hysteroscopy File') | translate" (nzOnCancel)="handleCancel()"
  nzCancelText="Cancel" nzOkText="Save" nzOkType="primary" [nzFooter]="null" class="custom-modal-class">
  <ng-container *nzModalContent>
    <form [formGroup]="hysteroscopyForm" (ngSubmit)="submitForm()"
      [ngClass]="{'hysteroscopy-submitted': hysteroscopySubmitted, 'hysteroscopy-not-submitted': !hysteroscopySubmitted}">

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>Anatomical Position</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <nz-select class="inputs hysteroscopy" nzShowSearch nzAllowClear [nzPlaceHolder]="'Anatomical Position' | translate"
            formControlName="anatomicalPositionValue" [nzLoading]="isLoading">
            @for (et of hysteroscopyDropdown?.anatomicalPosition; track et) {
              <nz-option [nzLabel]="et.name" [nzValue]="et.id"></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{"Date" | translate}}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input nz-input class="inputs hysteroscopy" type="date" [placeholder]="'Date...' | translate"
            formControlName="dateValue" [max]="this?.hysteroscopyForm?.value?.dateValue || getCurrentDate()" />
          </div>
        </div>

        <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
          <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
            <label>{{"File" | translate}}</label>
          </div>
          <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
            <input class="hysteroscopy upload" [ngClass]="{'ng-invalid' : !this.hysteroscopyForm.value?.fileValue}"
              style="margin-left:1em" type="file" (change)="onFileSelected($event)" accept=".jpeg,.png" />
            </div>
          </div>

          <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
            <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
              <label>{{"Description" | translate}}</label>
            </div>
            <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
              <input nz-input class="inputs hysteroscopy" type="text" [placeholder]="'Description...' | translate"
                formControlName="descriptionValue" />
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="end" class="footer">
              <button nz-button nzPrimary class="save-btn" type="submit" [nzLoading]="isLoading"
              [disabled]="isLoading">{{"Save" | translate}}</button>
              <button nz-button nzDanger class="cancel-btn" type="button" (click)="handleCancel()"
              [disabled]="isLoading">{{"Cancel" | translate}}</button>
            </div>
          </form>
        </ng-container>
      </nz-modal>
